import React from "react";
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import {
    Grid,
    Card,
    CardHeader,
    CardContent,
    CircularProgress,
    Button,
    TableCell,
    TableRow,
    Fab,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableBody,
    TablePagination
} from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { getSpecificClients } from "views/clients/api/apiClients";
import SelectClient from "common/components/custom/SelectClient";
import { getUserById, getUsers } from "../api/apiUsers";
import CreateOrUpdateUser from "./CreateOrUpdateUser";
import { getRoles } from "views/clients/api/apiClients";

class Users extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            specificsClients: [],
            isOpen: false,
            selectedClient: props.location.state && props.location.state.selectedClient ? props.location.state.selectedClient : null,
            users: [],
            userToEdit: null,
            dialogOpen: false,
            isLoading: true,
            activePage: 0,
            totalElements: 0,
            rowsPerPage: 25,
            roles: []
        };
    }

    async componentDidMount() {
        this.getSpecificClients()
        this.getRoles()
    }

    handleChangePage = (event, newPage) => {
        this.setState({ activePage: newPage }, () => this.getUsers(newPage))
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), activePage: 0 }, () => this.getUsers(this.state.activePage))
    };

    getSpecificClients = () => {
        getSpecificClients().then((response) => {
            let selectedClient = this.state.selectedClient !== null ? this.state.selectedClient : response.data.data.length === 0 ? null : response.data.data[0]
            this.setState({ specificsClients: response.data.data, selectedClient: selectedClient, isLoading: false }, () => selectedClient ? this.getUsers(0) : null);
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getRoles = () => {
        getRoles().then((response) => {
            this.setState({ roles: response.data.data });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getUsers = (page) => {
        getUsers({ params: { clientId: this.state.selectedClient.id, page: page, size: this.state.rowsPerPage } }).then((response) => {
            this.setState({
                users: response.data.data.content,
                totalElements: response.data.data.totalElements,
                isLoading: false
            });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getUserById = (id) => {
        getUserById(id).then(response => {
            this.setState({ userToEdit: response.data.data, isOpen: true });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_user_by_id"), { variant: 'error' });
        });
    }

    handleChange = (client) => {
        if (client !== null) {
            this.setState({ selectedClient: client }, () => this.getUsers(0, client.id))
        } else {
            this.setState({ selectedClient: null })
        }
    }

    closeDialog = () => {
        this.setState({ isOpen: false, userToEdit: null });
    }

    render() {

        let { users, isOpen, specificsClients, isLoading, selectedClient } = this.state;

        if (isLoading) {
            return (
                <div className="loading-position">
                    <CircularProgress className="spinner" color="primary" />
                </div>
            )
        }

        let usersList;
        let recordsNotFound;
        if (users && users.length > 0) {
            usersList = users.map((user, index) => {
                return <TableRow key={index}>
                    <TableCell>{user.firstName}</TableCell>
                    <TableCell>{user.lastName}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>{user.role}</TableCell>
                    <TableCell>{user.enabled ? <CheckIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'green' }} /> : <CloseIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'red' }} />}</TableCell>
                    <TableCell>
                        <Fab title={this.props.t("edit")} onClick={() => this.getUserById(user.id)} size="small" style={{ marginRight: 10 }} color="secondary" aria-label="edit">
                            <EditIcon />
                        </Fab>
                    </TableCell>
                </TableRow >
            });
        } else {
            recordsNotFound = <TableRow>
                <TableCell align="center" colSpan={6}>
                    <p>{this.props.t("no_records_found")}</p>
                </TableCell>
            </TableRow>
        }

        return <Grid container direction="row" spacing={2}>
            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                <CardHeader
                    title={this.props.t("users")}
                    action={
                        selectedClient !== null && <Button variant="contained" color="secondary" aria-label="edit" onClick={() => this.setState({ userToEdit: null, isOpen: true })} style={{ top: '4px' }}>
                            {this.props.t("add_new_user")}
                        </Button>
                    } />
                <Card>
                    <CardContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={2} sm={2} md={2} lg={2} xl={2}>
                                <Grid container direction="row" spacing={2}>
                                    <SelectClient
                                        specificsClients={specificsClients}
                                        selectedClient={selectedClient}
                                        handleChange={this.handleChange}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        {selectedClient !== null && <><Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="simple table" size="small" style={{ tableLayout: 'fixed' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row" width="20%">{this.props.t("first_name")}</TableCell>
                                                        <TableCell component="th" scope="row" width="20%">{this.props.t("last_name")}</TableCell>
                                                        <TableCell component="th" scope="row" width="30%">{this.props.t("email")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%">{this.props.t("role")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%">{this.props.t("enabled")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%"></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {usersList}
                                                    {recordsNotFound}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                            <TablePagination
                                component="div"
                                count={this.state.totalElements}
                                rowsPerPageOptions={[10, 25, 50, 100]}
                                page={this.state.activePage}
                                onPageChange={this.handleChangePage}
                                rowsPerPage={this.state.rowsPerPage}
                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                                backIconButtonText={this.props.t("previous_page")}
                                labelRowsPerPage={this.props.t("rows_per_page")}
                                nextIconButtonText={this.props.t("next_page")}
                            /></>}
                    </CardContent>
                </Card>
            </Grid>
            <CreateOrUpdateUser
                userModalOpen={isOpen}
                clientId={this.state.selectedClient && this.state.selectedClient.id}
                onClose={this.closeDialog}
                roleList={this.state.roles}
                userToEdit={this.state.userToEdit ? this.state.userToEdit : null}
                getUsers={() => this.getUsers(0)}
            />
        </Grid >
    }
}

export default withSnackbar(withTranslation()(Users))